import styled from 'styled-components';

const DesktopContainer = styled.div`
  .in-page-features-v4--copy-container,
  .in-page-features-v4--featured-content {
    display: block;

    img {
      max-width: 100%;
      max-height: 100%;
    }
  }

  .in-page-features-v4--copy-container {
    padding-top: 50px;
  }
`;

export { DesktopContainer };
